import React from 'react';
import { IconType } from '../../types';

export const InfoIcon = ({
  width = 24,
  height = 24,
  color = '#fff',
}: IconType) => (
  <svg
    width={width}
    height={height}
    viewBox={`0 0 ${width} ${height}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 6.74316C0 3.02037 3.1082 0 6.94175 0C10.7753 0 13.8835 3.02037 13.8835 6.74316C13.8835 10.4681 10.7753 13.4863 6.94175 13.4863C3.1082 13.4863 0 10.4681 0 6.74316ZM1.34355 6.7428C1.34355 9.74919 3.84784 12.1808 6.94173 12.1808C10.0367 12.1808 12.5399 9.74813 12.5399 6.7428C12.5399 3.7375 10.0345 1.30477 6.94173 1.30477C3.84795 1.30477 1.34355 3.73843 1.34355 6.7428ZM6.942 2.99076C7.59128 2.99076 8.11762 3.50204 8.11762 4.13275C8.11762 4.76345 7.59128 5.27473 6.942 5.27473C6.29272 5.27473 5.76638 4.76345 5.76638 4.13275C5.76638 3.50204 6.29272 2.99076 6.942 2.99076ZM8.17359 10.2235C8.35908 10.2235 8.50948 10.0774 8.50948 9.8972V9.24463C8.50948 9.06445 8.35908 8.91835 8.17359 8.91835H7.83769V6.19933C7.83769 6.01915 7.6873 5.87305 7.5018 5.87305H5.71038C5.52489 5.87305 5.37449 6.01915 5.37449 6.19933V6.8519C5.37449 7.03209 5.52489 7.17818 5.71038 7.17818H6.04628V8.91835H5.71038C5.52489 8.91835 5.37449 9.06445 5.37449 9.24463V9.8972C5.37449 10.0774 5.52489 10.2235 5.71038 10.2235H8.17359Z"
      fill={color}
    />
  </svg>
);
